var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.people_around),function(item){return _c('Person',{key:item.id,attrs:{"person":item}})}),_c('infinite-loading',{on:{"infinite":_vm.infiniteHandler}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }